import { call, put, takeLatest } from "redux-saga/effects";
import { CREATE_TICKET, CREATE_TICKET_API, GET_ALL_USERS, GET_ALL_USERS_API } from "./Constants";
import { setAllUsersSuccess, setAllUsersFail, createTicketFail, createTicketSuccess } from "./Actions";
import { ticketApi } from "../../../../shared/components/Service";
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";

function* fetchAllUsersData() {
  try {
    const response = yield call(ticketApi.get, GET_ALL_USERS_API);
    
    // If API returns { data: [] }
    yield put(setAllUsersSuccess(response.data));

  } catch (error) {
     yield put(addErrorAlert(`Failed to load Users: ${GET_ALL_USERS_API}`));
    yield put(setAllUsersFail(error.message || "Failed to fetch users"));
  }
}


function* createTicket(action) {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = yield call(
      ticketApi.post,
      CREATE_TICKET_API,
      action.payload,  
    
    );

    if (response.status === 200) {
      yield put(createTicketSuccess(response.data));
      yield put(addSuccessAlert( response.response?.message || "Ticket created successfully!"));
    } else {
      yield put(createTicketFail(response.response?.data));
      yield put(
        addErrorAlert(
          response.response?.data?.message ||  response.response?.message ||"Failed to create ticket"
        )
      );
    }
  } catch (error) {
    yield put(
      addErrorAlert(
        error?.response?.data?.msg ||
          `Failed to create ticket: ${CREATE_TICKET_API}`
      )
    );
    yield put(createTicketFail(error));
  }
}

export function* createTicketWatcher() {
  yield takeLatest(CREATE_TICKET.CREATE_TICKET_LOAD, createTicket);
}

export function* allUsersWatcher() {
  yield takeLatest(GET_ALL_USERS.GET_ALL_USERS_LOAD, fetchAllUsersData);
}
